(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7817],{

/***/ 47577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(89885);
!function(t,e){ true?module.exports=e():0}(this,function(){return r={},i.m=n=[function(t,n,e){"use strict";function r(t){for(var e in t)n.hasOwnProperty(e)||(n[e]=t[e])}Object.defineProperty(n,"__esModule",{value:!0}),r(e(2)),r(e(3))},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=Object.prototype,i="function"==typeof setImmediate&&"object"==typeof process&&"function"==typeof process.hrtime,o={NODE:i,BROWSER:!i,type:function(t){return r.toString.call(t).match(/\s(\w+)/i)[1].toLowerCase()},isset:function(t){return null!=t},ensureArray:function(t){return o.isset(t)?Array.isArray(t)?t:[t]:[]},getNumber:function(t,e,n){return"number"==typeof t?t<e?e:t:n},getBool:function(t,e){return"boolean"!=typeof t?e:t},setImmediate:function(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];return o.BROWSER?setTimeout(t.apply(null,e),0):setImmediate.apply(void 0,[t].concat(e))},clearImmediate:function(t){if(t)return o.BROWSER?clearTimeout(t):void clearImmediate(t)},isPromise:function(t){return t&&"promise"===o.type(t)&&"function"==typeof t.then}};e.utils=o},function(t,e,n){"use strict";var r=this&&this.__assign||function(){return(r=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)};Object.defineProperty(e,"__esModule",{value:!0});var i=n(0),o=n(1),s=Object.freeze({enabled:!0,tickDelay:0,tickInterval:1,totalRuns:null,startDate:null,stopDate:null,immediate:!1,removeOnCompleted:!1,callback:null}),u=(Object.defineProperty(a.prototype,"id",{get:function(){return this._.id},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"enabled",{get:function(){return this._.enabled},set:function(t){this._.enabled=o.utils.getBool(t,!0)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"tickDelay",{get:function(){return this._.tickDelay},set:function(t){this._.tickDelay=o.utils.getNumber(t,0,s.tickDelay)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"tickInterval",{get:function(){return this._.tickInterval},set:function(t){this._.tickInterval=o.utils.getNumber(t,1,s.tickInterval)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"totalRuns",{get:function(){return this._.totalRuns},set:function(t){this._.totalRuns=o.utils.getNumber(t,0,s.totalRuns)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"immediate",{get:function(){return this._.immediate},set:function(t){this._.immediate=o.utils.getBool(t,!1)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"currentRuns",{get:function(){return this._.currentRuns},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"time",{get:function(){var t=this._.timeOnFirstRun||0,e=this._.timeOnLastRun||0;return Object.freeze({started:t,stopped:e,elapsed:e-t})},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"callback",{get:function(){return this._.callback},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"removeOnCompleted",{get:function(){return this._.removeOnCompleted},set:function(t){this._.removeOnCompleted=o.utils.getBool(t,!1)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"completed",{get:function(){return!!this._markedCompleted||Boolean(this.totalRuns&&this.currentRuns>=this.totalRuns||this._.stopDate&&Date.now()>=this._.stopDate)},enumerable:!0,configurable:!0}),Object.defineProperty(a.prototype,"canRunOnTick",{get:function(){if(this._markedCompleted)return!1;var t=this._.startDate?Math.ceil((Date.now()-Number(this._.startDate))/this._timer.interval):this._timer.tickCount,e=!this._.startDate||Date.now()>=this._.startDate,n=t>this.tickDelay&&(t-this.tickDelay)%this.tickInterval==0;return Boolean(e&&n)},enumerable:!0,configurable:!0}),a.prototype.reset=function(t){if(this._.currentRuns=0,t){var e=t.id;if(e&&e!==this.id)throw new Error("Cannot change ID of a task.");t.id=this.id,this._init(t)}return this},a.prototype.toJSON=function(){var t=r({},this._);return delete t.callback,t},a.prototype._setTimer=function(t){this._timer=t},a.prototype._emit=function(t,e){var n={name:t,source:this};e instanceof Error?n.error=e:n.data=e,this._timer.emit(t,n)},a.prototype._done=function(){this.completed&&(this._markedCompleted=!0,this._.timeOnLastRun=Date.now(),this._timer._taskCompleted(this))},a.prototype._execCallback=function(){var e=this;try{var t=this.callback.apply(this,[this,function(){return e._done()}]);2<=this.callback.length||(o.utils.isPromise(t)?t.then(function(){e._done()}).catch(function(t){e._emit(i.TaskTimer.Event.TASK_ERROR,t)}):this._done())}catch(t){this._emit(i.TaskTimer.Event.TASK_ERROR,t)}},a.prototype._run=function(t){var e=this;this.enabled&&!this._markedCompleted&&(0===this.currentRuns&&(this._.timeOnFirstRun=Date.now()),this._.currentRuns++,t(),this.immediate?o.utils.setImmediate(function(){return e._execCallback()}):this._execCallback())},a.prototype._init=function(t){if(!t||!t.id)throw new Error("A unique task ID is required.");if("function"!=typeof t.callback)throw new Error("A callback function is required for a task to run.");var e=t.startDate,n=t.stopDate;if(e&&n&&n<=e)throw new Error("Task start date cannot be the same or after stop date.");this._markedCompleted=!1,this._=r({currentRuns:0},s),this._.id=String(t.id),this._.callback=t.callback,this._.startDate=t.startDate||null,this._.stopDate=t.stopDate||null,this.enabled=t.enabled,this.tickDelay=t.tickDelay,this.tickInterval=t.tickInterval,this.totalRuns=t.totalRuns,this.immediate=t.immediate,this.removeOnCompleted=t.removeOnCompleted},a);function a(t){this._init(t)}e.Task=u},function(t,e,n){"use strict";var r,i=this&&this.__extends||(r=function(t,e){return(r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)},function(t,e){function n(){this.constructor=t}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)});Object.defineProperty(e,"__esModule",{value:!0});var o,s,u,a,c=n(4),p=n(0),l=n(1),f=Object.freeze({interval:1e3,precision:!0,stopOnCompleted:!1}),h=(o=c.EventEmitter,i(m,o),Object.defineProperty(m.prototype,"interval",{get:function(){return this._.opts.interval},set:function(t){this._.opts.interval=l.utils.getNumber(t,20,f.interval)},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"precision",{get:function(){return this._.opts.precision},set:function(t){this._.opts.precision=l.utils.getBool(t,f.precision)},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"stopOnCompleted",{get:function(){return this._.opts.stopOnCompleted},set:function(t){this._.opts.stopOnCompleted=l.utils.getBool(t,f.stopOnCompleted)},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"state",{get:function(){return this._.state},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"time",{get:function(){var t=this._,e=t.startTime,n=t.stopTime,r={started:e,stopped:n,elapsed:0};if(e){var i=this.state!==m.State.STOPPED?Date.now():n;r.elapsed=i-e}return Object.freeze(r)},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"tickCount",{get:function(){return this._.tickCount},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"taskCount",{get:function(){return Object.keys(this._.tasks).length},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"taskRunCount",{get:function(){return this._.taskRunCount},enumerable:!0,configurable:!0}),Object.defineProperty(m.prototype,"runCount",{get:function(){return this._runCount},enumerable:!0,configurable:!0}),m.prototype.get=function(t){return this._.tasks[t]||null},m.prototype.add=function(t){var e=this;if(!l.utils.isset(t))throw new Error("Either a task, task options or a callback is required.");return l.utils.ensureArray(t).forEach(function(t){return e._add(t)}),this},m.prototype.remove=function(t){var e="string"==typeof t?t:t.id;if(t=this.get(e),!e||!t)throw new Error("No tasks exist with ID: '"+e+"'.");return t.completed&&0<this._.completedTaskCount&&this._.completedTaskCount--,this._.tasks[e]=null,delete this._.tasks[e],this._emit(m.Event.TASK_REMOVED,t),this},m.prototype.start=function(){return this._stop(),this._.state=m.State.RUNNING,this._runCount++,this._.tickCount=0,this._.taskRunCount=0,this._.stopTime=0,this._markTime(),this._.startTime=Date.now(),this._emit(m.Event.STARTED),this._run(),this},m.prototype.pause=function(){return this.state!==m.State.RUNNING||(this._stop(),this._.state=m.State.PAUSED,this._emit(m.Event.PAUSED)),this},m.prototype.resume=function(){return this.state===m.State.IDLE?this.start():this.state!==m.State.PAUSED||(this._runCount++,this._markTime(),this._.state=m.State.RUNNING,this._emit(m.Event.RESUMED),this._run()),this},m.prototype.stop=function(){return this.state!==m.State.RUNNING||(this._stop(),this._.stopTime=Date.now(),this._.state=m.State.STOPPED,this._emit(m.Event.STOPPED)),this},m.prototype.reset=function(){return this._reset(),this._emit(m.Event.RESET),this},m.prototype._emit=function(t,e){var n={name:t,source:this,data:e};return this.emit(t,n)},m.prototype._add=function(t){if("function"==typeof t&&(t={callback:t}),"object"!==l.utils.type(t)||t.id||(t.id=this._getUniqueTaskID()),this.get(t.id))throw new Error("A task with id '"+t.id+"' already exists.");var e=t instanceof p.Task?t:new p.Task(t);return e._setTimer(this),this._.tasks[e.id]=e,this._emit(m.Event.TASK_ADDED,e),this},m.prototype._stop=function(){this._.tickCountAfterResume=0,this._timeoutRef&&(clearTimeout(this._timeoutRef),this._timeoutRef=null),this._immediateRef&&(l.utils.clearImmediate(this._immediateRef),this._immediateRef=null)},m.prototype._reset=function(){this._={opts:(this._||{}).opts,state:m.State.IDLE,tasks:{},tickCount:0,taskRunCount:0,startTime:0,stopTime:0,completedTaskCount:0,resumeTime:0,hrResumeTime:null,tickCountAfterResume:0},this._stop()},m.prototype._taskCompleted=function(t){this._.completedTaskCount++,this._emit(m.Event.TASK_COMPLETED,t),this._.completedTaskCount===this.taskCount&&(this._emit(m.Event.COMPLETED),this.stopOnCompleted&&this.stop()),t.removeOnCompleted&&this.remove(t)},m.prototype._tick=function(){var t,e,n=this;this._.state=m.State.RUNNING;var r=this._.tasks;for(t in this._.tickCount++,this._.tickCountAfterResume++,this._emit(m.Event.TICK),r)(e=r[t])&&e.canRunOnTick&&e._run(function(){n._.taskRunCount++,n._emit(m.Event.TASK,e)});this._run()},m.prototype._markTime=function(){l.utils.BROWSER?this._.resumeTime=Date.now():this._.hrResumeTime=process.hrtime()},m.prototype._getTimeDiff=function(){if(l.utils.BROWSER)return Date.now()-this._.resumeTime;var t=process.hrtime(this._.hrResumeTime);return Math.ceil(1e3*t[0]+t[1]/1e6)},m.prototype._run=function(){var t=this;if(this.state===m.State.RUNNING){var e=this.interval;if(this.precision){var n=this._getTimeDiff();if(Math.floor(n/e)>this._.tickCountAfterResume)return void(this._immediateRef=l.utils.setImmediate(function(){return t._tick()}));e-=n%e}this._timeoutRef=setTimeout(function(){return t._tick()},e)}},m.prototype._getUniqueTaskID=function(){for(var t,e=this.taskCount;!t||this.get(t);)t="task"+ ++e;return t},m);function m(t){var e=o.call(this)||this;e._timeoutRef=null,e._immediateRef=null,e._runCount=0,e._reset(),e._.opts={};var n="number"==typeof t?{interval:t}:t||{};return e.interval=n.interval,e.precision=n.precision,e.stopOnCompleted=n.stopOnCompleted,e}e.TaskTimer=h,(s=h=h||{}).Task=p.Task,(u=s.State||(s.State={})).IDLE="idle",u.RUNNING="running",u.PAUSED="paused",u.STOPPED="stopped",(a=s.Event||(s.Event={})).TICK="tick",a.STARTED="started",a.RESUMED="resumed",a.PAUSED="paused",a.STOPPED="stopped",a.RESET="reset",a.TASK="task",a.TASK_ADDED="taskAdded",a.TASK_REMOVED="taskRemoved",a.TASK_COMPLETED="taskCompleted",a.TASK_ERROR="taskError",a.COMPLETED="completed",e.TaskTimer=h},function(t,e,n){"use strict";var r=Object.prototype.hasOwnProperty,h="~";function i(){}function u(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function o(t,e,n,r,i){if("function"!=typeof n)throw new TypeError("The listener must be a function");var o=new u(n,r||t,i),s=h?h+e:e;return t._events[s]?t._events[s].fn?t._events[s]=[t._events[s],o]:t._events[s].push(o):(t._events[s]=o,t._eventsCount++),t}function c(t,e){0==--t._eventsCount?t._events=new i:delete t._events[e]}function s(){this._events=new i,this._eventsCount=0}Object.create&&(i.prototype=Object.create(null),(new i).__proto__||(h=!1)),s.prototype.eventNames=function(){var t,e,n=[];if(0===this._eventsCount)return n;for(e in t=this._events)r.call(t,e)&&n.push(h?e.slice(1):e);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(t)):n},s.prototype.listeners=function(t){var e=h?h+t:t,n=this._events[e];if(!n)return[];if(n.fn)return[n.fn];for(var r=0,i=n.length,o=new Array(i);r<i;r++)o[r]=n[r].fn;return o},s.prototype.listenerCount=function(t){var e=h?h+t:t,n=this._events[e];return n?n.fn?1:n.length:0},s.prototype.emit=function(t,e,n,r,i,o){var s=h?h+t:t;if(!this._events[s])return!1;var u,a,c=this._events[s],p=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),p){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,r),!0;case 5:return c.fn.call(c.context,e,n,r,i),!0;case 6:return c.fn.call(c.context,e,n,r,i,o),!0}for(a=1,u=new Array(p-1);a<p;a++)u[a-1]=arguments[a];c.fn.apply(c.context,u)}else{var l,f=c.length;for(a=0;a<f;a++)switch(c[a].once&&this.removeListener(t,c[a].fn,void 0,!0),p){case 1:c[a].fn.call(c[a].context);break;case 2:c[a].fn.call(c[a].context,e);break;case 3:c[a].fn.call(c[a].context,e,n);break;case 4:c[a].fn.call(c[a].context,e,n,r);break;default:if(!u)for(l=1,u=new Array(p-1);l<p;l++)u[l-1]=arguments[l];c[a].fn.apply(c[a].context,u)}}return!0},s.prototype.on=function(t,e,n){return o(this,t,e,n,!1)},s.prototype.once=function(t,e,n){return o(this,t,e,n,!0)},s.prototype.removeListener=function(t,e,n,r){var i=h?h+t:t;if(!this._events[i])return this;if(!e)return c(this,i),this;var o=this._events[i];if(o.fn)o.fn!==e||r&&!o.once||n&&o.context!==n||c(this,i);else{for(var s=0,u=[],a=o.length;s<a;s++)(o[s].fn!==e||r&&!o[s].once||n&&o[s].context!==n)&&u.push(o[s]);u.length?this._events[i]=1===u.length?u[0]:u:c(this,i)}return this},s.prototype.removeAllListeners=function(t){var e;return t?(e=h?h+t:t,this._events[e]&&c(this,e)):(this._events=new i,this._eventsCount=0),this},s.prototype.off=s.prototype.removeListener,s.prototype.addListener=s.prototype.on,s.prefixed=h,s.EventEmitter=s,t.exports=s}],i.c=r,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)i.d(n,r,function(t){return e[t]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="lib/",i(i.s=0);function i(t){if(r[t])return r[t].exports;var e=r[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}var n,r});
//# sourceMappingURL=tasktimer.min.js.map

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useFetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83244);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44743);
/* harmony import */ var _apiHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65639);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54087);
/* harmony import */ var enums_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10367);







function fetcher(url, locale) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, locale) {
        var queryParams, ref, ref1, idToken, headers, _args = arguments;
        return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryParams = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {};
                    ;
                    _ctx.next = 4;
                    return (ref = _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === null || _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === void 0 ? void 0 : _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp.auth */ .H.auth()) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : ref1.getIdToken();
                case 4:
                    idToken = _ctx.sent;
                    headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": locale
                    };
                    if (idToken) {
                        headers["Authorization"] = "Bearer ".concat(idToken);
                    }
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .queryStringFromObject */ .jR)(queryParams)), {
                            method: "GET",
                            headers: headers
                        }).then(function(res) {
                            if (res.status === 204) {
                                resolve({});
                            } else if (res.status > 204) {
                                switch(res.status){
                                    case 402:
                                        reject(enums_errors__WEBPACK_IMPORTED_MODULE_5__/* .AppApiError.PaymentNeeded */ .u.PaymentNeeded);
                                        break;
                                    default:
                                        res.json().then(reject);
                                }
                            } else {
                                resolve(res.json());
                            }
                        }).catch(reject);
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}
// hooks use on client side
function useFetch(path, locale) {
    var canLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, queryParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (!path) {
        throw new Error("Path is required");
    }
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(canLoad ? path : null, function() {
        return fetcher(path, locale, queryParams);
    }, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
        refreshWhenHidden: false,
        refreshInterval: 0
    }), data = ref.data, error = ref.error, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate
    };
}


/***/ }),

/***/ 57817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(60950);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(65117);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/tasktimer/lib/tasktimer.min.js
var tasktimer_min = __webpack_require__(47577);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
;// CONCATENATED MODULE: ./models/VideoDetails.ts


var VideoDetails = /*#__PURE__*/ function() {
    "use strict";
    function VideoDetails() {
        (0,_class_call_check/* default */.Z)(this, VideoDetails);
    }
    VideoDetails.fromJSON = function fromJSON(json) {
        return Object.assign(new VideoDetails(), json);
    };
    (0,_create_class/* default */.Z)(VideoDetails, [
        {
            key: "title",
            get: function get() {
                return this.play.title;
            }
        },
        {
            key: "secondaryTitle",
            get: function get() {
                var ref;
                var ref1;
                return (ref1 = (ref = this.play.theatre) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "";
            }
        },
        {
            key: "hls",
            get: function get() {
                return this.streams.hls;
            }
        },
        {
            key: "dash",
            get: function get() {
                return this.streams.dash;
            }
        },
        {
            key: "videoDuration",
            get: function get() {
                return this.runtime;
            }
        },
        {
            key: "watchDuration",
            get: function get() {
                return this.user_progress;
            }
        },
        {
            key: "watchProgress",
            get: function get() {
                if (!this.videoDuration) {
                    return 0;
                }
                return this.watchDuration / this.videoDuration * 100 / 100;
            }
        },
        {
            key: "isCurrentlyWatched",
            get: function get() {
                return this.watchDuration > 60 && this.watchProgress < 0.98;
            }
        },
        {
            key: "customData",
            get: function get() {
                return this.custom_data;
            }
        },
        {
            key: "sessionId",
            get: function get() {
                return this.session_id;
            }
        },
        {
            key: "endCreditsTime",
            get: function get() {
                return this.credits_start || 0;
            }
        }
    ]);
    return VideoDetails;
}();
/* harmony default export */ var models_VideoDetails = (VideoDetails);

// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./api/useFetch.ts
var useFetch = __webpack_require__(45509);
// EXTERNAL MODULE: ./pages/watch-online/[slug]/index.module.scss
var index_module = __webpack_require__(17933);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./context/popupContext.tsx
var popupContext = __webpack_require__(30785);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
// EXTERNAL MODULE: ./components/AppLink/AppLink.tsx
var AppLink = __webpack_require__(3245);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
;// CONCATENATED MODULE: ./pages/watch-online/[slug]/index.tsx

// @ts-ignore


















var VideoComponent = dynamic_default()(__webpack_require__.e(/* import() */ 7412).then(__webpack_require__.bind(__webpack_require__, 87412)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87412)
            ];
        }
    },
    ssr: false
});
var video;
var analyticsTimer;
var TICK_UPDATE_WATCH_PROGRESS = 20;
var TICK_PLAY_UPDATE_ANALYTICS = 1;
var TICK_TRAILER_UPDATE_ANALYTICS_1 = 1;
var TICK_TRAILER_UPDATE_ANALYTICS_2 = 5;
var Watch = function(param) {
    var play = param.play, _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview, countryCode = param.countryCode;
    var requestNewVideoDetails = function requestNewVideoDetails() {
        return mutate().then(function(video) {
            return video.custom_data;
        });
    };
    var destroyAnalyticsTimer = function destroyAnalyticsTimer() {
        analyticsTimer === null || analyticsTimer === void 0 ? void 0 : analyticsTimer.stop();
        analyticsTimer === null || analyticsTimer === void 0 ? void 0 : analyticsTimer.removeAllListeners();
        analyticsTimer = null;
    };
    var trackViewAnalytics = /*
   * LET THERE BE ANALYTICS
   * Send update to the server every TICK_UPDATE (in seconds) should the video has not been paused.
   */ function trackViewAnalytics() {
        if (!analyticsTimer) {
            analyticsTimer = new tasktimer_min.TaskTimer(1000);
            var onTick;
            // performance tracking
            if (!isPreview) {
                onTick = function onTick() {
                    var ticks = analyticsTimer.tickCount;
                    if (ticks === TICK_PLAY_UPDATE_ANALYTICS) {
                        Analytics/* default.v2_playView */.ZP.v2_playView(play.title, play.theatre.name, "start");
                    }
                    // send watch progress to the backend every 20 seconds
                    if (ticks > 0 && ticks % TICK_UPDATE_WATCH_PROGRESS === 0) {
                        (0,client/* getSharedApiClient */.L)().updateVideoProgress(data.id, Math.floor(video.currentTime), TICK_UPDATE_WATCH_PROGRESS, videoDetails.sessionId);
                    }
                };
            } else {
                // trailer tracking
                onTick = function onTick() {
                    var ticks = analyticsTimer.tickCount;
                    if (ticks === TICK_TRAILER_UPDATE_ANALYTICS_1) {
                        Analytics/* default.v2_trailerView */.ZP.v2_trailerView(play.title, play.theatre.name, "start");
                    } else if (ticks === TICK_TRAILER_UPDATE_ANALYTICS_2) {
                        Analytics/* default.v2_trailerView */.ZP.v2_trailerView(play.title, play.theatre.name, "".concat(TICK_TRAILER_UPDATE_ANALYTICS_2, "_seconds"));
                        destroyAnalyticsTimer();
                    }
                };
            }
            analyticsTimer.on("tick", onTick);
            analyticsTimer.start();
        } else {
            analyticsTimer === null || analyticsTimer === void 0 ? void 0 : analyticsTimer.resume();
        }
    };
    var ref, ref1;
    var setPopupConfig = (0,popupContext/* usePopup */.BF)().setPopupConfig;
    var ref2 = (0,useTranslation/* default */.Z)(enums/* Namespace.Common */.lS.Common), lang = ref2.lang, t = ref2.t;
    var isUserLoaded = (0,authContext/* useAuth */.aC)().isUserLoaded;
    var ref3 = (0,react.useState)(false), showTimeoutError = ref3[0], setShowTimeoutError = ref3[1];
    var ref4 = (0,react.useState)(false), displayDonate = ref4[0], setDisplayDonate = ref4[1];
    var ref5 = (0,react.useState)(null), videoDetails = ref5[0], setVideoDetails = ref5[1];
    var router = (0,next_router.useRouter)();
    var ref6 = (0,useFetch/* useFetch */.i)("video/".concat((ref = play[isPreview ? "preview" : "video"]) === null || ref === void 0 ? void 0 : ref.id), lang, isUserLoaded), data = ref6.data, error = ref6.error, mutate = ref6.mutate;
    var loading = !error && !data;
    (0,react.useEffect)(function() {
        if (data) {
            var videoDetails = models_VideoDetails.fromJSON(data);
            setVideoDetails(videoDetails);
        }
    }, [
        data
    ]);
    (0,react.useEffect)(function() {
        return function() {
            setVideoDetails(null);
            destroyAnalyticsTimer();
        };
    }, []);
    (0,react.useEffect)(function() {
        if (error) {
            setPopupConfig({
                popupType: enums/* PopupType.BuySubscription */.kQ.BuySubscription,
                onClose: onVideoClose
            });
        }
    }, [
        error
    ]);
    var onVideoPlay = function() {
        trackViewAnalytics();
    };
    // stop tracking when playback ends
    var onPlaybackEnded = function() {
        if (isPreview) {
            Analytics/* default.v2_trailerView */.ZP.v2_trailerView(play.title, play.theatre.name, "finish");
        } else {
            Analytics/* default.v2_playView */.ZP.v2_playView(play.title, play.theatre.name, "finish");
        }
        destroyAnalyticsTimer();
    };
    // timeout error (empty buffer for too long etc.)
    var onTimeoutError = function() {
        setShowTimeoutError(true);
    };
    var onError = function() {
        destroyAnalyticsTimer();
    };
    var onEndCreditsStarted = function() {
        if (play.theatre.donations_allowed) {
            setDisplayDonate(true);
        }
    };
    var onVideoClose = function() {
        destroyAnalyticsTimer();
        router.back();
    };
    var onVideoPause = function() {
        analyticsTimer === null || analyticsTimer === void 0 ? void 0 : analyticsTimer.pause();
    };
    var onInit = function(video_) {
        video = video_;
    };
    if (showTimeoutError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "player-error",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "shaka-text-text-titles",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: play.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: play.theatre.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "shaka-close-button",
                    onClick: onVideoClose,
                    children: t("input_close")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "player-error-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: t("play-detail:playback_error_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("play-detail:playback_error_content")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-primary",
                            onClick: onVideoClose,
                            children: t("play-detail:playback_error_action")
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        hiddenWrappers: true,
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,helpers/* basicSEO */.Fi)(t("seo:watch_performance_title", {
                    title: play.title,
                    theatre: (ref1 = play.theatre) === null || ref1 === void 0 ? void 0 : ref1.name
                }), play.about, play.poster_url)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                baseColor: "#22222E",
                highlightColor: "#2D2D3A",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).container,
                    children: [
                        loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: [
                                        "shaka-text-text-titles",
                                        (index_module_default()).noBg
                                    ].join(" "),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (index_module_default()).controlsPlaceholder,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: [
                                        "shaka-close-button",
                                        (index_module_default()).closeButtonPlaceholder
                                    ].join(" "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {})
                                })
                            ]
                        }),
                        !loading && !error && videoDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponent, {
                            videoDetails: videoDetails,
                            onError: onError,
                            onTimeoutError: onTimeoutError,
                            onEndCreditsStarted: onEndCreditsStarted,
                            onPlay: onVideoPlay,
                            onPlaybackEnded: onPlaybackEnded,
                            onClose: onVideoClose,
                            onPause: onVideoPause,
                            onInit: onInit,
                            onNewDRMCustomDataRequest: requestNewVideoDetails
                        }),
                        displayDonate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "donate-play",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: play.theatre.poster_url,
                                    alt: play.theatre.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        t("play-detail:donate_bubble_title"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLink/* default */.Z, {
                                            href: helpers/* Permalink.donateTheatre */.xm.donateTheatre(play.theatre),
                                            children: t("play-detail:donate_bubble_link")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = ((0,authContext/* withForcePlanToLoggedInUnsubs */.DE)(Watch));


/***/ }),

/***/ 17933:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_slug__container__9j_9K","controlsPlaceholder":"_slug__controlsPlaceholder__T1ADP","noBg":"_slug__noBg__oIzCc","closeButtonPlaceholder":"_slug__closeButtonPlaceholder__iw01R"};

/***/ })

}]);